var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0005 0.5C4.1635 0.5 4.3165 0.5795 4.41 0.7135L7.91 5.7135C8.017 5.866 8.029 6.0655 7.944 6.231C7.8575 6.3965 7.687 6.5 7.5005 6.5H0.499502C0.313002 6.5 0.142502 6.3965 0.0560023 6.231C-0.0289977 6.0655 -0.0169977 5.866 0.0900023 5.7135L3.59 0.7135C3.6835 0.5795 3.8365 0.5 3.9995 0.5H4.0005Z",
    fill: "#D01A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedGroup);
export default __webpack_public_path__ + "static/media/RedGroup.e937cc37b495f6ae522524a2cee77969.svg";
export { ForwardRef as ReactComponent };